import { Vector3, Color3 } from '@babylonjs/core';

export interface Platform {
  position: Vector3;
  size: Vector3;
  color: Color3;
  type: 'normal' | 'checkpoint' | 'start' | 'finish' | 'kill' | 'moving' | 'bouncy';
  movement?: {
    axis: 'x' | 'y' | 'z';
    distance: number;
    speed: number;
  };
}

export interface ObbyLevelData {
  name: string;
  platforms: Platform[];
  spawnPoint: Vector3;
  skyColor: Color3;
}

export class ObbyLevel {
  public static createLevel1(): ObbyLevelData {
    const platforms: Platform[] = [];

    // Start platform
    platforms.push({
      position: new Vector3(0, 0, 0),
      size: new Vector3(5, 1, 5),
      color: new Color3(0.2, 0.8, 0.2),
      type: 'start',
    });

    // Section 1: Simple jumps
    platforms.push({
      position: new Vector3(0, 0, 8),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    platforms.push({
      position: new Vector3(4, 1, 12),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    platforms.push({
      position: new Vector3(0, 2, 16),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    // First checkpoint
    platforms.push({
      position: new Vector3(-4, 3, 20),
      size: new Vector3(4, 1, 4),
      color: new Color3(1, 0.8, 0),
      type: 'checkpoint',
    });

    // Section 2: Kill blocks challenge
    platforms.push({
      position: new Vector3(-4, 3, 26),
      size: new Vector3(2, 1, 2),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    // Kill block (lava)
    platforms.push({
      position: new Vector3(-4, 3, 30),
      size: new Vector3(6, 0.5, 2),
      color: new Color3(1, 0.2, 0),
      type: 'kill',
    });

    platforms.push({
      position: new Vector3(-4, 3, 34),
      size: new Vector3(2, 1, 2),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    platforms.push({
      position: new Vector3(0, 4, 38),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    // Second checkpoint
    platforms.push({
      position: new Vector3(4, 5, 42),
      size: new Vector3(4, 1, 4),
      color: new Color3(1, 0.8, 0),
      type: 'checkpoint',
    });

    // Section 3: Moving platforms
    platforms.push({
      position: new Vector3(4, 5, 48),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.6, 0.3, 0.8),
      type: 'moving',
      movement: {
        axis: 'x',
        distance: 6,
        speed: 2,
      },
    });

    platforms.push({
      position: new Vector3(4, 6, 54),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.6, 0.3, 0.8),
      type: 'moving',
      movement: {
        axis: 'y',
        distance: 3,
        speed: 1.5,
      },
    });

    platforms.push({
      position: new Vector3(0, 7, 60),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    // Third checkpoint
    platforms.push({
      position: new Vector3(-4, 8, 64),
      size: new Vector3(4, 1, 4),
      color: new Color3(1, 0.8, 0),
      type: 'checkpoint',
    });

    // Section 4: Bouncy platforms
    platforms.push({
      position: new Vector3(-4, 8, 70),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.9, 0.4, 0.7),
      type: 'bouncy',
    });

    platforms.push({
      position: new Vector3(0, 12, 76),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    platforms.push({
      position: new Vector3(4, 14, 82),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.9, 0.4, 0.7),
      type: 'bouncy',
    });

    // Final stretch
    platforms.push({
      position: new Vector3(0, 18, 88),
      size: new Vector3(3, 1, 3),
      color: new Color3(0.4, 0.4, 0.9),
      type: 'normal',
    });

    // Finish platform
    platforms.push({
      position: new Vector3(0, 20, 95),
      size: new Vector3(6, 1, 6),
      color: new Color3(0.2, 1, 0.4),
      type: 'finish',
    });

    return {
      name: 'Obby Level 1',
      platforms,
      spawnPoint: new Vector3(0, 2, 0),
      skyColor: new Color3(0.5, 0.7, 1),
    };
  }
}
